export default [
  { value: '', text: 'Select feeding activity' },
  { value: 'good', text: 'Good' },
  { value: 'fair', text: 'Fair' },
  { value: 'poor', text: 'Poor' },
  { value: 'unknown', text: 'Unknown' },
];
